<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M2 6H10" stroke="#44454E" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
